import { trackError } from '../../utils/trackError';
import type { ECommerce4Transaction, TrackECommerceArg } from './types';
import { isGa4EcommerceData, isUaEcommerceData } from './utils';

export const ECOMMERCE_TRANSACTION_BOUNDARY = 'trackECommerceData';
export const ECOMMERCE_TRANSACTION_MESSAGE =
  'transactionId is required to correctly track eCommerce in Google Analytics 4';
export const handleECommerceTransactionDataError = (
  ga4Data: ECommerce4Transaction
) => {
  if (!ga4Data?.transaction_id) {
    void trackError(
      new Error(
        `${ECOMMERCE_TRANSACTION_MESSAGE}. Transaction data: ${JSON.stringify(
          ga4Data
        )}`
      ),
      ECOMMERCE_TRANSACTION_BOUNDARY
    );
  }
};

export const GA4_EVENT_NAME_BOUNDARY = 'trackECommerceData';
export const GA4_EVENT_NAME_MESSAGE =
  'event_name does not match the GA4 naming requirements ([A-Za-z][A-Za-z0-9_]{0,39}) and might be rejected by Google Analytics 4';
const GA4_EVENT_NAME_REGEX = /^[A-Za-z][A-Za-z0-9_]{0,39}$/;
export const handleGa4EventNameError = (eventName: string) => {
  if (!GA4_EVENT_NAME_REGEX.test(eventName)) {
    void trackError(
      new Error(
        `${GA4_EVENT_NAME_MESSAGE}. Received event_name: "${eventName}"`
      ),
      GA4_EVENT_NAME_BOUNDARY
    );
  }
};

export const ECOMMERCE_BOUNDARY = 'trackECommerce';
export const ECOMMERCE_DATA_MESSAGE =
  'Cannot process eCommerce tracking if eCommerceData is not defined';
export const ECOMMERCE_INVALID_DATA_MESSAGE =
  'The provided eCommerce data are nor GA4 nor UA eCommerce data';
export const ECOMMERCE_ITEMS_MESSAGE =
  'eCommerce tracking will be performed without items';
export const checkECommerceDataError = (
  eCommerceData: TrackECommerceArg | ECommerce4Transaction
) => {
  if (!eCommerceData || Object.keys(eCommerceData).length === 0) {
    void trackError(new Error(ECOMMERCE_DATA_MESSAGE), ECOMMERCE_BOUNDARY);
    return true;
  }
  if (!isGa4EcommerceData(eCommerceData) && !isUaEcommerceData(eCommerceData)) {
    void trackError(
      new Error(`${ECOMMERCE_INVALID_DATA_MESSAGE}`),
      ECOMMERCE_BOUNDARY
    );
    return true;
  }
  if (isGa4EcommerceData(eCommerceData) && eCommerceData.items.length === 0) {
    void trackError(
      new Error(
        `${ECOMMERCE_ITEMS_MESSAGE}. eCommerceData: ${JSON.stringify(
          eCommerceData
        )}`
      ),
      ECOMMERCE_BOUNDARY
    );
    return true;
  }
  if (isUaEcommerceData(eCommerceData) && eCommerceData.products.length === 0) {
    void trackError(
      new Error(
        `${ECOMMERCE_ITEMS_MESSAGE}. eCommerceData: ${JSON.stringify(
          eCommerceData
        )}`
      ),
      ECOMMERCE_BOUNDARY
    );
    return true;
  }
  return false;
};
